import React, { useState } from "react";
import { useNavigate , useParams } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [body, setBody] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);
 
  const API = (process.env.REACT_APP_API_URL || "").replace(/\/$/, ""); 
  const navigate = useNavigate();  

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });

    if (!name || !email || !body) {
      setStatus({ type: "error", msg: "Please fill all fields." });
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${API}/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message: body }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Failed to send message");

      setStatus({ type: "ok", msg: "Message sent. Thank you!" });
      setName(""); setEmail(""); setBody("");
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", msg: err.message });
    } finally {
      setLoading(false);
    }
  };

 return (
    <div style={styles.page}>
      {/* button to return to the menu */}
      <button style={styles.back} onClick={() => navigate(`/`)}>←</button>
      <h1 style={styles.title}>Contact Us</h1>
      <p style={styles.subtitle}>Have questions or feedback? Let us know!</p>

      <form style={styles.form} onSubmit={onSubmit}>
        <label style={styles.label}>Name</label>
        <input
          type="text"
          placeholder="Your Name"
          style={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label style={styles.label}>Email</label>
        <input
          type="email"
          placeholder="you@email.com"
          style={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label style={styles.label}>Message</label>
        <textarea
          placeholder="Write your message..."
          style={styles.textarea}
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />

        <button type="submit" style={styles.submit} disabled={loading}>
          {loading ? "Sending..." : "Send Message"}
        </button>

        {status.msg && (
          <div style={{ marginTop: 10, color: status.type === "ok" ? "green" : "red" }}>
            {status.msg}
          </div>
        )}
      </form>
    </div>
  );
}

const styles = {
  page: {
    background: blue,
    color: yellow,
    minHeight: "100vh",
    fontFamily: "Futura, sans-serif",
    padding: "40px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "28px",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "16px",
    marginBottom: "30px",
    textAlign: "center",
  },
  form: {
    background: blue,
    borderRadius: "12px",
    padding: "20px",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  label: {
    color: blue,
    fontWeight: "500",
    fontSize: "14px",
    marginBottom: "-5px",
  },
  input: {
    padding: "12px",
    fontSize: "14px",
    backgroundColor: yellow,
    color: blue, 
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    outline: "none",
  },
  textarea: {
    padding: "12px",
    fontSize: "14px",
    backgroundColor: yellow,
    color: blue,
    border: "none",
    borderRadius: "6px",
    height: "90px",
    fontWeight: "bold",
    resize: "none",
    outline: "none",
  },
  submit: {
    padding: "12px",
    backgroundColor: yellow,
    color: blue,
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    fontSize: "15px",
    cursor: "pointer",
  },
  back: {
    alignSelf: "flex-start",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: yellow,
    cursor: "pointer",
    marginBottom: "20px",
  },
};

export default Contact;
